export const MAPS_API_KEY = 'AIzaSyC-L32qkzY6CneHu0-7u3t-FckNS7HkC8g';
